/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Comment } from './Comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
} from './Comment';
import type { ConfigurationInfo } from './ConfigurationInfo';
import {
    ConfigurationInfoFromJSON,
    ConfigurationInfoFromJSONTyped,
    ConfigurationInfoToJSON,
} from './ConfigurationInfo';
import type { DeliveryMode } from './DeliveryMode';
import {
    DeliveryModeFromJSON,
    DeliveryModeFromJSONTyped,
    DeliveryModeToJSON,
} from './DeliveryMode';
import type { EntryArrivalSlot } from './EntryArrivalSlot';
import {
    EntryArrivalSlotFromJSON,
    EntryArrivalSlotFromJSONTyped,
    EntryArrivalSlotToJSON,
} from './EntryArrivalSlot';
import type { PointOfService } from './PointOfService';
import {
    PointOfServiceFromJSON,
    PointOfServiceFromJSONTyped,
    PointOfServiceToJSON,
} from './PointOfService';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { PriceData } from './PriceData';
import {
    PriceDataFromJSON,
    PriceDataFromJSONTyped,
    PriceDataToJSON,
} from './PriceData';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { SAPAdditionalPrice } from './SAPAdditionalPrice';
import {
    SAPAdditionalPriceFromJSON,
    SAPAdditionalPriceFromJSONTyped,
    SAPAdditionalPriceToJSON,
} from './SAPAdditionalPrice';
import type { SAPAppliedDiscount } from './SAPAppliedDiscount';
import {
    SAPAppliedDiscountFromJSON,
    SAPAppliedDiscountFromJSONTyped,
    SAPAppliedDiscountToJSON,
} from './SAPAppliedDiscount';
import type { StatusSummary } from './StatusSummary';
import {
    StatusSummaryFromJSON,
    StatusSummaryFromJSONTyped,
    StatusSummaryToJSON,
} from './StatusSummary';

/**
 * Request body parameter that contains details such as the quantity of product (quantity), and the pickup store name (deliveryPointOfService.name)
 * 
 * The DTO is in XML or .json format.
 * @export
 * @interface OrderEntry
 */
export interface OrderEntry {
    /**
     * Entry number of the order entry
     * @type {number}
     * @memberof OrderEntry
     */
    entryNumber?: number;
    /**
     * Quantity number of items in order entry
     * @type {number}
     * @memberof OrderEntry
     */
    quantity?: number;
    /**
     * 
     * @type {Price}
     * @memberof OrderEntry
     */
    basePrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof OrderEntry
     */
    totalPrice?: Price;
    /**
     * 
     * @type {Product}
     * @memberof OrderEntry
     */
    product?: Product;
    /**
     * Flag defining if order entry item is updateable
     * @type {boolean}
     * @memberof OrderEntry
     */
    updateable?: boolean;
    /**
     * 
     * @type {DeliveryMode}
     * @memberof OrderEntry
     */
    deliveryMode?: DeliveryMode;
    /**
     * Configuration info of order entry
     * @type {Array<ConfigurationInfo>}
     * @memberof OrderEntry
     */
    configurationInfos?: Array<ConfigurationInfo>;
    /**
     * List of aggregated status information per entry, relevant if the entry is configurable and its configuration contains one or many issues in different severities. Note that configurators typically raise such issues only in case the parent document is changeable. In this case the issues (depending on their severity) need to be fixed before a checkout can be done. This means this segment can be present for a cart entry, for order entries it will always be empty
     * @type {Array<StatusSummary>}
     * @memberof OrderEntry
     */
    statusSummaryList?: Array<StatusSummary>;
    /**
     * 
     * @type {PointOfService}
     * @memberof OrderEntry
     */
    deliveryPointOfService?: PointOfService;
    /**
     * 
     * @type {Price}
     * @memberof OrderEntry
     */
    cancelledItemsPrice?: Price;
    /**
     * Quantity number of cancellable items in order entry
     * @type {number}
     * @memberof OrderEntry
     */
    cancellableQuantity?: number;
    /**
     * 
     * @type {Price}
     * @memberof OrderEntry
     */
    returnedItemsPrice?: Price;
    /**
     * Quantity number of returnable items in order entry
     * @type {number}
     * @memberof OrderEntry
     */
    returnableQuantity?: number;
    /**
     * List of item arrival slot
     * @type {Array<EntryArrivalSlot>}
     * @memberof OrderEntry
     */
    arrivalSlots?: Array<EntryArrivalSlot>;
    /**
     * Additional prices on this entry set by the pricing engine. The PRIOR type provides the original price before discounts for strikethrough display. Null when not available.
     * @type {Array<SAPAdditionalPrice>}
     * @memberof OrderEntry
     */
    sapAdditionalPrices?: Array<SAPAdditionalPrice>;
    /**
     * Discounts applied to this entry by the pricing engine. Null when not available.
     * @type {Array<SAPAppliedDiscount>}
     * @memberof OrderEntry
     */
    sapAppliedDiscounts?: Array<SAPAppliedDiscount>;
    /**
     * List of order entry comments.
     * @type {Array<Comment>}
     * @memberof OrderEntry
     */
    comments?: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    externalEntryNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderEntry
     */
    backLog?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrderEntry
     */
    dispatched?: Date;
    /**
     * 
     * @type {PriceData}
     * @memberof OrderEntry
     */
    totalPriceWithTax?: PriceData;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    invoiceToken?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderEntry
     */
    lastPurchasedQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderEntry
     */
    deliveredQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    lastPurchasedUnit?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderEntry
     */
    lastPurchasedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderEntry
     */
    plannedDeliveryDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof OrderEntry
     */
    totalPurchasedQuantityLast24Months?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    externalProductCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    externalProductPackagingDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    externalProductBrandFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    externalProductName?: string;
}

/**
 * Check if a given object implements the OrderEntry interface.
 */
export function instanceOfOrderEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderEntryFromJSON(json: any): OrderEntry {
    return OrderEntryFromJSONTyped(json, false);
}

export function OrderEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryNumber': !exists(json, 'entryNumber') ? undefined : json['entryNumber'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'basePrice': !exists(json, 'basePrice') ? undefined : PriceFromJSON(json['basePrice']),
        'totalPrice': !exists(json, 'totalPrice') ? undefined : PriceFromJSON(json['totalPrice']),
        'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product']),
        'updateable': !exists(json, 'updateable') ? undefined : json['updateable'],
        'deliveryMode': !exists(json, 'deliveryMode') ? undefined : DeliveryModeFromJSON(json['deliveryMode']),
        'configurationInfos': !exists(json, 'configurationInfos') ? undefined : ((json['configurationInfos'] as Array<any>).map(ConfigurationInfoFromJSON)),
        'statusSummaryList': !exists(json, 'statusSummaryList') ? undefined : ((json['statusSummaryList'] as Array<any>).map(StatusSummaryFromJSON)),
        'deliveryPointOfService': !exists(json, 'deliveryPointOfService') ? undefined : PointOfServiceFromJSON(json['deliveryPointOfService']),
        'cancelledItemsPrice': !exists(json, 'cancelledItemsPrice') ? undefined : PriceFromJSON(json['cancelledItemsPrice']),
        'cancellableQuantity': !exists(json, 'cancellableQuantity') ? undefined : json['cancellableQuantity'],
        'returnedItemsPrice': !exists(json, 'returnedItemsPrice') ? undefined : PriceFromJSON(json['returnedItemsPrice']),
        'returnableQuantity': !exists(json, 'returnableQuantity') ? undefined : json['returnableQuantity'],
        'arrivalSlots': !exists(json, 'arrivalSlots') ? undefined : ((json['arrivalSlots'] as Array<any>).map(EntryArrivalSlotFromJSON)),
        'sapAdditionalPrices': !exists(json, 'sapAdditionalPrices') ? undefined : ((json['sapAdditionalPrices'] as Array<any>).map(SAPAdditionalPriceFromJSON)),
        'sapAppliedDiscounts': !exists(json, 'sapAppliedDiscounts') ? undefined : ((json['sapAppliedDiscounts'] as Array<any>).map(SAPAppliedDiscountFromJSON)),
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(CommentFromJSON)),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'externalEntryNumber': !exists(json, 'externalEntryNumber') ? undefined : json['externalEntryNumber'],
        'backLog': !exists(json, 'backLog') ? undefined : json['backLog'],
        'dispatched': !exists(json, 'dispatched') ? undefined : (new Date(json['dispatched'])),
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceDataFromJSON(json['totalPriceWithTax']),
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'invoiceToken': !exists(json, 'invoiceToken') ? undefined : json['invoiceToken'],
        'lastPurchasedQuantity': !exists(json, 'lastPurchasedQuantity') ? undefined : json['lastPurchasedQuantity'],
        'deliveredQuantity': !exists(json, 'deliveredQuantity') ? undefined : json['deliveredQuantity'],
        'lastPurchasedUnit': !exists(json, 'lastPurchasedUnit') ? undefined : json['lastPurchasedUnit'],
        'lastPurchasedDate': !exists(json, 'lastPurchasedDate') ? undefined : (new Date(json['lastPurchasedDate'])),
        'plannedDeliveryDate': !exists(json, 'plannedDeliveryDate') ? undefined : (new Date(json['plannedDeliveryDate'])),
        'totalPurchasedQuantityLast24Months': !exists(json, 'totalPurchasedQuantityLast24Months') ? undefined : json['totalPurchasedQuantityLast24Months'],
        'externalProductCode': !exists(json, 'externalProductCode') ? undefined : json['externalProductCode'],
        'externalProductPackagingDescription': !exists(json, 'externalProductPackagingDescription') ? undefined : json['externalProductPackagingDescription'],
        'externalProductBrandFamily': !exists(json, 'externalProductBrandFamily') ? undefined : json['externalProductBrandFamily'],
        'externalProductName': !exists(json, 'externalProductName') ? undefined : json['externalProductName'],
    };
}

export function OrderEntryToJSON(value?: OrderEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryNumber': value.entryNumber,
        'quantity': value.quantity,
        'basePrice': PriceToJSON(value.basePrice),
        'totalPrice': PriceToJSON(value.totalPrice),
        'product': ProductToJSON(value.product),
        'updateable': value.updateable,
        'deliveryMode': DeliveryModeToJSON(value.deliveryMode),
        'configurationInfos': value.configurationInfos === undefined ? undefined : ((value.configurationInfos as Array<any>).map(ConfigurationInfoToJSON)),
        'statusSummaryList': value.statusSummaryList === undefined ? undefined : ((value.statusSummaryList as Array<any>).map(StatusSummaryToJSON)),
        'deliveryPointOfService': PointOfServiceToJSON(value.deliveryPointOfService),
        'cancelledItemsPrice': PriceToJSON(value.cancelledItemsPrice),
        'cancellableQuantity': value.cancellableQuantity,
        'returnedItemsPrice': PriceToJSON(value.returnedItemsPrice),
        'returnableQuantity': value.returnableQuantity,
        'arrivalSlots': value.arrivalSlots === undefined ? undefined : ((value.arrivalSlots as Array<any>).map(EntryArrivalSlotToJSON)),
        'sapAdditionalPrices': value.sapAdditionalPrices === undefined ? undefined : ((value.sapAdditionalPrices as Array<any>).map(SAPAdditionalPriceToJSON)),
        'sapAppliedDiscounts': value.sapAppliedDiscounts === undefined ? undefined : ((value.sapAppliedDiscounts as Array<any>).map(SAPAppliedDiscountToJSON)),
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(CommentToJSON)),
        'status': value.status,
        'externalEntryNumber': value.externalEntryNumber,
        'backLog': value.backLog,
        'dispatched': value.dispatched === undefined ? undefined : (value.dispatched.toISOString()),
        'totalPriceWithTax': PriceDataToJSON(value.totalPriceWithTax),
        'unit': value.unit,
        'invoiceToken': value.invoiceToken,
        'lastPurchasedQuantity': value.lastPurchasedQuantity,
        'deliveredQuantity': value.deliveredQuantity,
        'lastPurchasedUnit': value.lastPurchasedUnit,
        'lastPurchasedDate': value.lastPurchasedDate === undefined ? undefined : (value.lastPurchasedDate.toISOString()),
        'plannedDeliveryDate': value.plannedDeliveryDate === undefined ? undefined : (value.plannedDeliveryDate.toISOString()),
        'totalPurchasedQuantityLast24Months': value.totalPurchasedQuantityLast24Months,
        'externalProductCode': value.externalProductCode,
        'externalProductPackagingDescription': value.externalProductPackagingDescription,
        'externalProductBrandFamily': value.externalProductBrandFamily,
        'externalProductName': value.externalProductName,
    };
}

